export enum BoundaryContainerMode {
  "PRIMARY" = 0,
  "SECONDARY" = 1
}
